import React from 'react';
import "../App.css";

const ImageLink = () => {
  const data = [
    {
      id: 1,
      href: 'https://apps.shopify.com/zip-code-validator',
      img: 'asset/Zipcode.png'
    },
    {
      id: 2,
      href: 'https://apps.shopify.com/smart-age-verification',
      img: 'asset/smtage.png'
    },
    {
      id: 3,
      href: 'https://apps.shopify.com/smart-store-locator',
      img: 'asset/store.png'
    },
  ]
  return (
    <React.Fragment>
      <div className='col-lg-12 col-md-12 col-sm-12 width-class'>
        {data.map((item)=> (              
              <a href={item.href} target="_blank" rel="noopener noreferrer" className='img-padding'><img src={item.img} alt='..' className='img-round'/></a>
              ))}
        </div> 
      </React.Fragment>          
  )
}

export default ImageLink;